import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

import { RatioRow, RatiosBlock, SyntageRatios } from '@data/interfaces/risk-scorecard.interface'
import { flagsText, formatMetricValue, formatMonth } from '../risk-scorecard.labels'
import { RiskScorecardTabBase } from '../risk-scorecard-tab.base'

/**
 * Ratios (plan v4.2 §8b.2 y §8b.3, D-42): primero los de Rendafin por ejercicio —los grupos de la hoja «Ratios
 * anuales» del Excel con sus defectos corregidos, ★ los que usa la calculadora— y abajo los de Syntage como
 * referencia, que antes vivían en la sub-pestaña Análisis.
 */
@Component({
  selector: 'app-ciec-ratios-tab',
  templateUrl: './ciec-ratios-tab.component.html',
  styleUrls: ['./ciec-ratios-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CiecRatiosTabComponent extends RiskScorecardTabBase {
  /**
   * Los ratios de Syntage que guardó el análisis (`result.financial_ratios`). Se usan cuando la calculadora no tiene
   * foto que leer (un análisis anterior a la foto): así la pestaña no pierde lo que antes se veía en Análisis.
   */
  @Input() fallbackSyntageRatios: SyntageRatios | null = null

  ratios: RatiosBlock | null = null
  effectiveYear: string | null = null

  readonly flagsText = flagsText
  readonly month = formatMonth

  get syntageRatios(): SyntageRatios | null {
    return this.ratios?.syntage ?? this.fallbackSyntageRatios ?? null
  }

  /** Sin estados financieros no hay ratios por ejercicio; Flujos y los de Syntage pueden seguir. */
  get hasYears(): boolean {
    return (this.ratios?.years.length ?? 0) > 0
  }

  /** El grupo trae la columna «Últimos 12 meses» (solo el de Flujos). */
  hasTrailing(group: RatiosBlock['groups'][number]): boolean {
    return group.ratios.some((row) => row.trailing12m !== undefined)
  }

  value(row: RatioRow, value: number | null | undefined): string {
    return formatMetricValue(value, row.unit)
  }

  protected override onResult(): void {
    this.ratios = this.result?.ratiosByYear ?? null
    this.effectiveYear = this.result?.statements?.effectiveYear ?? null
  }
}
